import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { Endpoints } from '../../../endpoints';
import { NgxSpinnerService } from 'ngx-spinner';
import {catchError, finalize, tap, of} from 'rxjs';
import { DialogService } from '../../../_modal/dialog.service';
import { LoggerService } from '../../../_services/logger.service';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import {MatAnchor} from "@angular/material/button";
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import {HttpClient} from "@angular/common/http";
@Component({
    selector: 'app-client-poc-details',
    standalone: true,
    imports: [CommonModule, MatCardModule, RouterOutlet, MatAnchor, RouterLink, RouterLinkActive],
    templateUrl: './clients-poc-details.component.html',
    styleUrls: ['./clients-poc-details.component.scss'],
    providers: [Endpoints]
})
export class ClientsPocDetailsComponent implements OnInit {
    clientId: string = '';
    public clientPocDetails: any;
    public clientContacts :any;

    constructor(
        private route: ActivatedRoute,
        private apiService: ApiService,
        private endpoints: Endpoints,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private loggerService: LoggerService,
        public themeService: CustomizerSettingsService,
        private http : HttpClient
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.clientId = params.get('id') || '';
            if (this.clientId) {
                //this.fetchClientDetails(this.clientId);
                this.loadData(this.clientId);
            }
        });
    }

    fetchClientDetails(clientId: string) {
        this.spinner.show();
        const clientUrl = `${this.endpoints.client_poc_base_endpoint}/${clientId}`;

        console.log(clientUrl)
        this.apiService.get('', clientUrl).pipe(
            tap((response: any) => {
                console.log(response.status)
                if (response.status) {
                    this.clientPocDetails = response.data;
                }
            }),
            catchError((error: { status: number }) => {
                return of(null);
            }),
            finalize(() => this.spinner.hide())
        ).subscribe();
    }

    loadData(clientId: string) {
        const clientUrl = `${this.endpoints.client_poc_base_endpoint}/${clientId}`;
        console.log(clientUrl)
        this.http.get<any>(clientUrl).subscribe(
            {
                next : data => {
                    this.clientContacts = data;
                    console.log(data)
                },
                error : err => {
                    console.log(err)
                }
            }
        );
    }



    onEdit() {
        // Logique pour modifier le client
        console.log(`Editing client with ID: ${this.clientId}`);
        // Ajoutez la logique pour rediriger vers une page de modification, si nécessaire
    }

    onDelete() {
        // Logique pour supprimer le client
        console.log(`Deleting client with ID: ${this.clientId}`);
        // Ajoutez la logique pour appeler l'API de suppression, si nécessaire
    }
}

